
<script>
import findKey from "lodash/findKey";

const idsDict = {
  pic: 4,
  music: 5,
  musicType: 5,
  gif: 4,
  video: 1,
  teamTemplate: 50
};

export default {
  data() {
    return {
      idsDict,
      cateOptions: [],
      selectedCateIndex: -1
    };
  },
  methods: {
    resetSelectedCateIndex() {
      this.selectedCateIndex = -1;
      this.cateOptions = [];
    },
    getUserCategories({ type, share = 0, own = 0 }, ev) {
      if (
        $(ev.currentTarget)
          .closest(".data-body")
          .hasClass("operation")
      ) {
        return;
      }
      this.resetSelectedCateIndex();
      let id;
      if (typeof type === "number") {
        id = type;
      } else {
        id = idsDict[type];
      }
      let link = `/api/user/material/category?type=${id}&share=${share}`;
      if (own) {
        link += "&ourself=1";
      }
      if (id == 1) {
        link += '&fileType=26';
      }
      return this.$http.get(link).then(res => {
        this.cateOptions = [].concat(res.data.data).reverse();
      });
    },
    getDataByUserCate(index) {
      if (index == null) {
        index = this.selectedCateIndex;
      } else {
        this.selectedCateIndex = index;
      }
      let cate = this.cateOptions[index] || {};
      let uiType = findKey(this.dataArray, v => v.judge);
      this.dataArray[uiType].pIndex = 1;
      this.getUserData(uiType, cate.id);
    },
    getUIType() {
      let uiType = findKey(this.dataArray, v => v.judge);
      return uiType;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/userCategoriesMixin.vue